import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// import { actions } from '../actions/app';

import SearchTextFieldContainer from './SearchTextFieldContainer';

class HeaderContainer extends React.PureComponent {
  render() {
    return (
      <SearchTextFieldContainer
        size="large"
      />
    );
  }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => bindActionCreators({
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HeaderContainer);



// WEBPACK FOOTER //
// ./src/containers/HeaderContainer.js